module.exports = __webpack_public_path__ + "static/game-3a74c007367ab8b3f57dc2ad2b8a0440.svg";